var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-wrapper"},[_c('div',{staticClass:"callout--gallery-with-text"},[_c('silent-box',{attrs:{"gallery":_vm.gallery}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }